const pathNames = typeof window !== 'undefined' && window.location.pathname.length > 1
    ? window.location.pathname.split('/').splice(1)
    : [];
export function usePathParams() {
    return pathNames;
}
export function usePathParam(index, defaultValue = 'undefined') {
    return pathNames[index] || defaultValue;
}
